import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'second-meeting-second-step',
  templateUrl: './second-meeting-second-step.component.html',
  styleUrls: ['../../meeting-form.component.scss']
})
export class SecondMeetingSecondStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
